import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useStore } from "@store/store";
import Loader from "@components/loader";
import { routes } from "@utils/constant";
import API from "@services/axios";
import { csvDetailStyle } from "./style";
import {
  FETCH_CSV_DETAIL,
  FETCH_CSV_DETAIL_FAILURE,
  FETCH_CSV_DETAIL_SUCCESS
} from "@utils/actionTypes";
import CsvTable from './table';
import siteLogo from "@assets/images/logo-white.svg";

function CsvDetail() {
  const classes = csvDetailStyle();
  const [state, dispatch] = useStore();
  const { id } = useParams();
  const history = useHistory();

  const getCsvDetail = async () => {
    try {
      dispatch({ type: FETCH_CSV_DETAIL });
      const { data } = await API.get(`invoices/${id}/previewCSV`);
      dispatch({ type: FETCH_CSV_DETAIL_SUCCESS, payload: data.data });
    } catch (error) {
      dispatch({ type: FETCH_CSV_DETAIL_FAILURE, payload: error });
      if (error?.response?.status === 404) history.push(routes.pageNotFound);
    }
  };

  useEffect(() => {
    getCsvDetail();
  }, []);

  const {
    csvDetailData,
    loadingCsvDetail,
  } = state.invoice || {};

  const {
    childOrganisations = {},
    customerName,
    customerAddress,
    totalNet,
    totalTax,
    totalGross,
  } = csvDetailData || {};

  return (
    <>
      <div className={classes.csvDetailWrapper}>
        <Loader loading={loadingCsvDetail} />
        <div className="csv-detail-page">
          <div className="inner-page">
            <div className="csv-detail-wrapper">
              <div className="content-wrapper">
                {/* Header Section */}
                <div className="header">
                  <div className="top-header clearfix">
                    {/* Left: Logo */}
                    <div className="logo">
                      <img src={siteLogo} alt="Wymap"/>
                    </div>

                    {/* Middle: Company Info */}
                    <div className="middle-title">
                      <strong>{childOrganisations?.name}</strong>
                      <p>
                        {[
                          childOrganisations?.address1,
                          childOrganisations?.address2,
                          childOrganisations?.suburb,
                          childOrganisations?.states?.name,
                          childOrganisations?.postalCode,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </p>
                      {childOrganisations?.phone && (
                        <p>{childOrganisations?.phone}</p>
                      )}
                    </div>

                    {/* Right: Bill To */}
                    <div className="right-block">
                      <p>
                        <strong>Bill To:</strong> {customerName}
                      </p>
                      <p>
                        {customerAddress}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Content Block */}
                <div className="content-block">
                  <div className="table-responsive">
                    <CsvTable
                      csvData={csvDetailData?.csvData}
                      totals={{
                        totalNet,
                        totalTax,
                        totalGross,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CsvDetail;
